import React from 'react';

export default function IntellectualPropertyRights() {
  return (
    <div className="bg-white min-h-screen flex flex-col py-10 px-2">
      <div className="max-w-3xl mx-auto bg-white rounded-xl shadow-xl border border-gray-200 p-8">

        <h1 className="text-3xl font-bold text-purple-600 mb-6 text-center">
          Intellectual Property Rights
        </h1>

        <p className="text-gray-700 mb-8">
          This policy explains the ownership, protection, and enforcement of intellectual property (IP) across the Million2Trillion (M2T) ecosystem.
        </p>

        <h2 className="text-2xl font-semibold text-blue-900 mt-8 mb-2">
          Platform Intellectual Property
        </h2>
        <ul className="list-disc text-gray-700 space-y-3 pl-6 mb-6">
          <li>The Million2Trillion brand, logo, domain, platform software, code, designs, AI models, backend engines, data architecture, and business process systems are fully owned and copyrighted by M2T Global Technologies.</li>
          <li>Unauthorized copying, reverse engineering, cloning, redistribution, or resale of any internal platform technology is strictly prohibited under international IP laws.</li>
          <li>Platform intellectual property remains permanently owned by M2T even if user accounts are terminated or suspended.</li>
        </ul>

        <h2 className="text-2xl font-semibold text-blue-900 mt-8 mb-2">
          User Intellectual Property
        </h2>
        <ul className="list-disc text-gray-700 space-y-3 pl-6 mb-6">
          <li>All original educational content, courses, signals, code snippets, or strategy models created by verified users remain fully owned by the respective content creator.</li>
          <li>By uploading content, users grant M2T a limited, non-exclusive license to display, distribute, showcase, and promote that content inside the M2T ecosystem only.</li>
          <li>Any unauthorized copying, piracy, redistribution, or resale of user content by other users is strictly prohibited and enforceable through legal action.</li>
        </ul>

        <h2 className="text-2xl font-semibold text-blue-900 mt-8 mb-2">
          Trademark Protection
        </h2>
        <ul className="list-disc text-gray-700 space-y-3 pl-6 mb-6">
          <li>The M2T Global Technologies name, "Million2Trillion", logo design, and product branding are registered and protected trademarks under applicable national and international laws.</li>
          <li>Unauthorized usage of M2T trademarks for commercial sales, false representations, or misleading business activities is strictly prohibited.</li>
        </ul>

        <h2 className="text-2xl font-semibold text-blue-900 mt-8 mb-2">
          Violation Reporting &amp; Enforcement
        </h2>
        <ul className="list-disc text-gray-700 space-y-3 pl-6 mb-6">
          <li>IP violation complaints may be submitted via our official legal email channel for full case investigation.</li>
          <li>Offenders may face full account bans, civil litigation, financial penalties, or criminal prosecution depending on violation severity.</li>
          <li>M2T reserves the right to pursue damages or file DMCA takedown actions against third-party IP infringement attempts.</li>
        </ul>

        <p className="text-gray-500 italic mt-10">
          Protecting both platform and user intellectual property protects long-term verified trust. M2T operates zero-tolerance IP violation enforcement.
        </p>
      </div>
    </div>
  );
}
